import { FiArrowRight, FiMail } from 'react-icons/fi';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import ProjectCard from './ProjectCard';
import useProjects from './useProjects';
import { useSiteProfile } from './ProfileContext';
import styles from './Portfolio.module.css';

const skills = [
  'Java', 'Spring Boot', 'Spring Security', 'MyBatis', 'MySQL',
  'React', 'JavaScript', 'REST APIs', 'Azure', 'Git',
];

const HomePage = () => {
  const { t } = useTranslation();
  const profile = useSiteProfile();
  const projects = useProjects();
  return <div>
    <section className={styles.hero}>
      <h1>{t('home.greeting')} <span className={styles.heroName}>{profile.displayName}</span></h1>
      <h2>{profile.homeHeadline}</h2>
      <p className={styles.heroLead}>{profile.homeIntro}</p>
      <div className={styles.heroActions}>
        <Link to="/projects" className={styles.primaryButton}>{t('home.viewProjects')}</Link>
        <a href={`mailto:${profile.email}`} className={styles.iconLink} aria-label={t('footer.email')}><FiMail /></a>
      </div>
    </section>

    <section className={styles.section}>
      <div className={styles.sectionHeading}>
        <h2>{t('nav.projects')}</h2>
      </div>
      <div className={styles.featuredGrid}>
        {projects.slice(0, 3).map((project) => <ProjectCard key={project.slug} project={project} />)}
      </div>
      <Link to="/projects" className={styles.sectionLink}>{t('home.allProjects')} <FiArrowRight /></Link>
    </section>

    <section className={styles.section}>
      <div className={styles.sectionHeading}>
        <h2>{t('home.skills')}</h2>
      </div>
      <div className={styles.skillList}>
        {skills.map((skill) => <span key={skill}>{skill}</span>)}
      </div>
    </section>

    <section className={`${styles.section} ${styles.ctaSection}`}>
      <div className={styles.sectionHeading}>
        <h2>{t('nav.writing')}</h2>
      </div>
      <p>{t('home.writingIntro')}</p>
      <Link to="/writing" className={styles.primaryButton}>{t('home.readArticles')}</Link>
    </section>
  </div>;
};

export default HomePage;
